import Component from '@glimmer/component';

import type { Theme } from 'webapp/enums/enums';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import type MetricLimitationCumulative from 'webapp/models-custom/metric-limitation/cumulative';
import type MetricLimitations from 'webapp/models-custom/metric-limitations';

export interface Args {
	metricLimitations: MetricLimitations;
	onChange: (isCumulative: boolean) => void;
	theme?: Theme | string;
	size?: string;
}

export default class FormCumulativeSwitchComponent extends Component<Args> {
	get dateRange() {
		return this.args.metricLimitations?.dateRange;
	}

	get limitation(): MetricLimitationCumulative | null {
		return this.args.metricLimitations?.limitationForCumulative;
	}
	<template>
		<div class="cumulative-switch">

			<label>Cumulative</label>

			<FormCheckboxSwitchComponent
				@name="cumulative"
				@selected={{this.dateRange.granulationCumulative}}
				@onChange={{@onChange}}
				@isDisabled={{this.limitation.onlyOneOptionAvailable}}
				@theme={{@theme}}
				@size={{@size}}
			/>

			{{#if this.limitation.infoText}}
				<ToolTipWithIconComponent @text={{this.limitation.infoText}} @maxWidth={{250}} />
			{{/if}}

		</div>
	</template>
}
